"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=14271%3A176))
 * @trackcomponent
 * @lastsynced 2026-09-30T17:16:17.000Z
 * @optimized using svgo:^3.3.4
 */
export const BSRHeart = createSVGIcon(
  <path
    d="M20.445 4.804a5.305 5.305 0 0 1 0 7.504L12 20.75l-8.445-8.442a5.305 5.305 0 0 1 0-7.504 5.31 5.31 0 0 1 7.507 0l.938.938.938-.938a5.31 5.31 0 0 1 7.507 0Z"
    stroke="currentColor"
    strokeWidth="1.5"
  />,
  "BSRHeart",
  (strictLocalize) => ({
    className: iconCls(),
    color: iconColor.primary,
    fill: "none",
    titleAccess: strictLocalize({
      id: "KOuc/j",
      defaultMessage: "Save",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    viewBox: "0 0 24 24",
  })
);
